import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavController } from '@ionic/angular';
import { placeholder } from 'src/app/models/placeholder';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'retail-list-card',
  templateUrl: './retail-list-card.component.html',
  styleUrls: ['./retail-list-card.component.scss'],
})
export class RetailListCardComponent implements OnInit {
  @Input() retailerList: any;
  @Input() type: any;
  @Input() selectedLocation: any;
  @Input() currency: any;
  @Input() airportCode: string; // for analytics context
  @Input() flow: string = 'dutyfree'; // for analytics context
  @Output() navigateWithLocation = new EventEmitter<any>();

  public imagePlaceholder: string = placeholder;
  currencyCode: string;

  constructor(
    private navControl: NavController,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.currencyCode = this.currency;
  }
  navigateFunction(item) {
    this.navigateWithLocation.emit(item);
    if (this.type === 'dutyfree') {
      this.analyticsService.trackDutyfreePackageSelected(
        {
          title: item?.title,
          storeName: item?.storeName,
          subCategory: item?.subCategory,
          tag: item?.tag,
          itemType: item?.itemType,
          productCancellable: item?.productCancellable,
          status: item?.status,
          packageId: item?.id,
          packageName: item?.title,
          retailerId: item?.retailerId,
          retailerName: item?.retailerName,
          airportCode: this.airportCode,
          locationName: item?.locationName,
          currency: this.currency,
          originalPrice: item?.origPrice,
          finalPrice: item?.finalPrice,
        },
        this.flow
      );
    }
    if (this.type === 'lounges') {
      this.analyticsService.trackUnified('book_now_clicked', {
        flow: 'shared',
        outcome: 'success',
        legacy_event_name: 'button_clicked',
        component: 'retail-list-card',
        button: 'book-now-button',
      });
    }
  }
}
